interface GaugeProps {
  score: number; // 0 ~ 100
  size?: number; // SVG width & height
}

export const CircularGauge = ({ score, size = 110 }: GaugeProps) => {
  const STROKE = 12;
  const cx = size / 2;
  const cy = size / 2;
  const r = (size - STROKE) / 2; // 여백 10px
  const max = 100;

  // 각도
  const startAngle = -90;
  const endAngle = 265;
  const angle = startAngle - (score / max) * (endAngle - startAngle);

  // 극좌표 계산
  const polar = (cx: number, cy: number, r: number, deg: number) => {
    const rad = (deg * Math.PI) / 180;
    return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
  };

  // 트랙
  const trackStart = polar(cx, cy, r, startAngle);
  const trackEnd = polar(cx, cy, r, endAngle);
  const trackD = `
    M ${trackStart.x} ${trackStart.y}
    A ${r} ${r} 0 1 1 ${trackEnd.x} ${trackEnd.y}
  `;

  // 진행
  const progEnd = polar(cx, cy, r, angle);
  const deltaAngle = Math.abs(angle - startAngle);
  const largeArc = deltaAngle > 180 ? 1 : 0;

  const progD = `
    M ${trackStart.x} ${trackStart.y}
    A ${r} ${r} 0 ${largeArc} 0 ${progEnd.x} ${progEnd.y} 
  `;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <defs>
        <linearGradient id="gaugeGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FFA44A" />
          <stop offset="100%" stopColor="#FF7A3D" />
        </linearGradient>
        <filter id="soft" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity="0.18" />
        </filter>
      </defs>

      {/* 트랙 */}
      <path
        d={trackD}
        stroke="#E5E7EB"
        strokeWidth={STROKE}
        strokeLinecap="round"
        fill="none"
      />

      {/* 진행 */}
      <path
        d={progD}
        stroke="url(#gaugeGrad)"
        strokeWidth={STROKE}
        strokeLinecap="round"
        fill="none"
        // style={{ filter: "url(#soft)" }}
      />

      {/* 노브 */}
      <circle cx={progEnd.x} cy={progEnd.y} r={STROKE / 2} fill="#FF7A3D" />
    </svg>
  );
};
